define({
    BASLER_CONTACT_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.draft.account.dto.BaslerContactDTO',
    MFP_VEHICLE_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.lob.mfp.draft.dto.MFPVehicle_ExtDTO',
    MFP_LINE_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.lob.mfp.draft.dto.MFPDraftDataExtension_ExtDTO',
    MFP_PROOF_OF_INSURANCE_QUESTIONS_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.binding.dto.BaslerProofOfInsuranceDTO',
    QUOTE_DTO: 'edge.capabilities.quote.quoting.dto.QuoteDTO',
    QUOTE_DATA_DTO: 'edge.capabilities.quote.dto.QuoteDataDTO',
    COVERAGE_DTO: 'edge.capabilities.quote.coverage.dto.CoverageDTO',
    DEALER_CONTACT_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.draft.account.dto.DealerContactDTO',
    PARTNER_DETAILS_DTO: 'ch.baloise.gw.pc.edge.capabilities.quote.draft.dto.PartnerDetailsDTO',
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/constants/MFPDtoClasses.js